import React from 'react'
import classes from './Divider.module.sass'

const Divider = ({ children }) =>
  <div className={classes.divider}>{children}</div>

export default Divider
